module.exports = __webpack_public_path__ + "img/social.40c17b8a.gif";